import React from 'react'

const AddColumnButton = ({
  onAddNewColumn,
  disabled = false,
  stickyTop = 0
}) => (
  <th
    className='header-cell sticky-header'
    style={{
      width: '80px',
      padding: '2px',
      background: '#0078d4',
      top: `${stickyTop}px`,
      zIndex: 1000
    }}
  >
    <button
      onClick={disabled ? undefined : onAddNewColumn}
      disabled={disabled}
      title='列を追加'
      style={{
        width: '100%',
        height: '100%',
        minHeight: '32px',
        border: '1px dashed #fff',
        background: 'transparent',
        color: '#fff',
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.65 : 1,
        fontSize: '20px',
        fontWeight: 'bold',
        borderRadius: '4px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: 'all 0.2s'
      }}
      onMouseOver={(e) => {
        if (disabled) return
        e.currentTarget.style.background = 'rgba(255,255,255,0.2)'
        e.currentTarget.style.borderColor = '#fff'
        e.currentTarget.style.borderStyle = 'solid'
      }}
      onMouseOut={(e) => {
        if (disabled) return
        e.currentTarget.style.background = 'transparent'
        e.currentTarget.style.borderStyle = 'dashed'
      }}
    >
      +
    </button>
  </th>
)

export default AddColumnButton
